import React from 'react';
import { ReactNode } from 'react';
import AccordionItem from './accordion-item';
import { useState } from 'react';


export type AccordionData = {
  titleEnglish: String;
  titleChinese: String;
  time: String;
  active:Boolean;
  content: ReactNode |null;
  language:string;
};

function Accordion({ items }: { items: AccordionData[] }) {
  const [currentIdx, setCurrentIdx] = useState(-1);
  const btnOnClick = (idx: number) => {
    setCurrentIdx((currentValue) => (currentValue !== idx ? idx : -1));
  };

  return (
    <ul className="accordion">
      {items.map((item, idx) => (
        <AccordionItem 
          key={idx}
          data={item}
          isOpen={idx === currentIdx}
          btnOnClick={() => btnOnClick(idx)}
        />
      ))}
    </ul>
  );
}


export default Accordion;